<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />

      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo.png" height="25" alt="Finlink Logo">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
      </b-link>

      <SidebarToggler class="d-md-down-none" display="lg" />

      <b-navbar-nav class="ml-auto mr-3">
        <Notifications />

        <AppHeaderDropdown right no-caret>
          <template slot="header">
            <div class="d-flex align-items-center text-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
              <div class="ml-1 mr-3">
                {{ authUser.displayName }}
                <small class="d-block text-primary">
                  {{ authUser.roleName }}
                </small>
              </div>
              <i class="fa fa-caret-down"></i>
            </div>
          </template>\
          <template slot="dropdown">
            <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
          </template>
        </AppHeaderDropdown>
      </b-navbar-nav>
    </AppHeader>

    <div class="app-body">
      <SideBar />

      <main class="main">
        <Breadcrumb :list="list"/>

        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import SideBar from "../UI/components/SideBar";
import Notifications from "../UI/components/Notifications";
import { Header as AppHeader, HeaderDropdown as AppHeaderDropdown, SidebarToggler, SidebarMinimizer, Breadcrumb } from '@coreui/vue';

import { removeUser } from '../services/auth';
import { mapState } from 'vuex';

export default {
  name: 'DefaultContainer',
  mounted(){
    this.$store.dispatch('getNotifications');
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState(['authUser']),
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
    async logout(){
      await removeUser();
      this.$store.dispatch('setAuthUser', null);
      this.$router.replace('/login');
    }
  },
  components: {
    AppHeader,
    AppHeaderDropdown,
    Breadcrumb,
    SidebarToggler,
    SidebarMinimizer,
    SideBar,
    Notifications
  }
}
</script>
